import jake from "@/assets/testi-jake.jpg";
import devin from "@/assets/testi-devin.jpg";
import natalie from "@/assets/testi-natalie.jpg";
import nick from "@/assets/testi-nick.jpg";
import travis from "@/assets/testi-travis.jpg";
import luther from "@/assets/testi-luther.jpg";
import landricus from "@/assets/testi-landricus.jpg";
import samuel from "@/assets/testi-samuel.jpg";

// Verbatim testimonials. Do not paraphrase.
export const TESTIMONIALS = [
  {
    id: "jake",
    name: "Jake R",
    photo: jake,
    paragraphs: [
      "I couldn't be happier to have found Shawn when I did, except to say I wish I had met him sooner. I reached out to Shawn to look into something I had been thinking about for two years and since that day only a few short months ago he has been a weekly presence in my journey to the kind of financial independence I had been looking for.",
      "Full of knowledge, and relatable experience, it has been a very growth oriented period since I met him. From books to read, to podcasts and concepts to research, to meeting in person just to talk thru what Being your Own Bank is, and how to get there, Shawn treats you like you're his only client.",
      "I am extremely grateful for his patience through the application process, his constant motivation, and for being the catalyst for getting me on the true path to financial independence through Infinite Banking.",
    ],
  },
  {
    id: "devin",
    name: "Devin S",
    photo: devin,
    paragraphs: [
      "Working with Shawn has been a very positive and eye-opening experience. From the very start, he has provided me with resources, education, and ongoing support that gave me a much clearer understanding of infinite banking and how it can truly benefit my family for years to come. Shawn has walked with me through every step of the process, making sure I felt confident, comfortable, and fully informed about the decisions I was making. He doesn't just present information; he takes the time to explain, answer questions, and make sure I understand how the strategies apply to my situation.",
      "What stands out most is that Shawn is not only professional and knowledgeable, but he also comes across as a genuine family man who really cares about helping others. His passion for teaching and spreading the value of infinite banking shows in the way he communicates and the patience he has in guiding people through what could otherwise feel overwhelming. I've come away from this experience with peace of mind, knowing that I've put something in place that will create security and opportunity for me and my family. I would gladly recommend Shawn to anyone looking to take control of their financial future through infinite banking.",
    ],
  },
  {
    id: "natalie",
    name: "Natalie S",
    photo: natalie,
    paragraphs: [
      "Working with Shawn has been a standout experience. He took the time to explain the concept with patience, clarity, and kindness. He talked me through my hesitations in a genuine way. I feel like consulting with him was always a two way conversation. He's generous with his knowledge and acts as a true coach, meaning he's down to earth and genuinely in this for the right reasons. Because of that, our family (we purchased three policies) feels confident in our structure and ready to move forward with implementation. We trust that we're well set up for success. Highly recommended if you want someone who teaches, supports, and walks alongside you. I believe in him and value surrounding myself with like-minded powerhouse people like Shawn in my corner.",
    ],
  },
  {
    id: "nick",
    name: "Nick P",
    photo: nick,
    paragraphs: [
      "Shawn introduced me to infinite banking and, like many people my age, I wish I had been introduced to this concept many years ago. With the information and knowledge that he has shared with me, I am confident that I can build generational wealth for my family moving forward. Shawn is extremely knowledgeable and is willing to answer any questions you might have. He will guide you through the steps to get you started with infinite banking and be there every step of the way.",
    ],
  },
  {
    id: "travis",
    name: "Travis R",
    photo: travis,
    paragraphs: [
      "I highly recommend Shawn King, my financial coach for the past year, especially for anyone exploring the Infinite Banking Concept. He is full of recommendations and other sources to get the information across and through his contacts he will teach you how to become your own banker. Despite my unpredictable schedule and living on the other side of the world, Shawn always makes time for me and is consistently available when I need him. He's patient, knowledgeable, and genuinely cares about helping his clients succeed. Beyond his professionalism, Shawn loves to travel and is a hardworking family man dedicated to providing for his beautiful family—something that shows his integrity and dedication to his work. I couldn't ask for a better advisor.",
    ],
  },
  {
    id: "luther",
    name: "Luther D",
    photo: luther,
    paragraphs: [
      "Shawn King made getting my infinite banking style policy an incredibly easy process. He has a true gift for breaking down complex financial concepts into simple, understandable terms. His expertise and patience gave me complete confidence in my decision. It's clear he is passionate about educating and empowering his clients. I highly recommend Shawn to anyone exploring this powerful financial strategy.",
    ],
  },
  {
    id: "landricus",
    name: "Landricus R",
    photo: landricus,
    paragraphs: [
      "Although I haven't been on the IBC path for very long, the learning experience, help and access to information has been great! Mr. Shawn you really have been a great source of information and the fact that you keep in contact says a lot about your character. It truly has been an experience that I'm glad to learn and be apart of. Thank you for the support and consistent updates on what's going on.",
    ],
  },
  {
    id: "samuel",
    name: "Samuel S",
    photo: samuel,
    paragraphs: [
      "I'm very grateful for the opportunity to work with Shawn. He has done so much for our family in such a short time. I truly appreciate the time and patience he has invested in me to explain everything I need to know about Infinite Banking. I'm looking forward to growing alongside him on this journey. I highly recommend working with him as a coach and teacher.",
    ],
  },
];

export const HOMEPAGE_PRIMARY = ["jake", "devin", "natalie"];
export const HOMEPAGE_MORE = ["nick", "travis", "luther", "landricus", "samuel"];
// Strategy-call page: testimonials emphasizing education, patience, clarity, support, trust.
export const STRATEGY_CALL_IDS = ["jake", "devin", "luther"];
// About page: emphasize Shawn personally — patience, responsiveness, long-term guidance, clarity, trust.
export const ABOUT_IDS = ["jake", "travis", "natalie"];
export const ABOUT_MORE = ["devin", "nick", "luther", "landricus", "samuel"];

export const getTestimonials = (ids) =>
  ids.map((id) => TESTIMONIALS.find((t) => t.id === id)).filter(Boolean);
